import React, { useEffect, useState } from 'react';
import MasonryLayout from './MasonryLayout';
import { client } from '../client';
import { searchPinQuery } from '../utils/data';
import Spinner from './Spinner';
import Navbar from './Navbar';

const Search = ({ user }) => {
  const [pins, setPins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (searchTerm !== '') {
      setLoading(true);
      const query = searchPinQuery(searchTerm.toLowerCase(), user?._id);
      client.fetch(query).then((data) => {
        setPins(data);
        setLoading(false);
      });
    } else {
      setLoading(true);
    }
  }, [searchTerm]);

  return (
    <div>
      <div className="flex-initial bg-mainBg">
        <Navbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} user={user && user} />
      </div>
      {loading && <Spinner message="Searching..." />}
      {(pins?.length !== 0) && <MasonryLayout pins={pins} />}
      {pins?.length === 0 && searchTerm !== '' && !loading && (
        <div className="mt-10 text-center text-xl ">Nothing Found, Try again</div>
      )}
    </div>
  );
};

export default Search;
